import './App.css';
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import { rutas } from './rutas'; 

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Navigate to={"/login"} replace/>} />

        {rutas.map(
						(ruta, indice) => {
							return (
								<Route 
									path={ruta.ruta} 
									key={indice}
									element={ruta.component}
									/>
							)})}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
